import {
  SmallGroupActivityEvaluation,
  SmallGroupEvalCriterion,
} from '../../../types/smallGroup';
import ApprovalStampBox from '../ApprovalStampBox';
import '../../quality/EducationAnnualPlanTab.css';
import '../../quality/QualityShell.css';
import '../../product/InspectionFormSheet.css';
import '../../product/NonconformanceReportPanel.css';

interface Props {
  detail: SmallGroupActivityEvaluation;
}

function newId() {
  return `${Date.now()}-${Math.random().toString(36).slice(2, 8)}`;
}

function defaultCriteria(): SmallGroupEvalCriterion[] {
  return [
    { id: newId(), criterion: '목표 달성도', score: '', comment: '' },
    { id: newId(), criterion: '참여도', score: '', comment: '' },
    { id: newId(), criterion: '개선 효과', score: '', comment: '' },
    { id: newId(), criterion: '지속 가능성', score: '', comment: '' },
  ];
}

function parseCriteria(json?: string | null): SmallGroupEvalCriterion[] {
  if (!json?.trim()) return defaultCriteria();
  try {
    const parsed = JSON.parse(json);
    if (!Array.isArray(parsed) || parsed.length === 0) return defaultCriteria();
    return parsed.map((row: Partial<SmallGroupEvalCriterion>) => ({
      id: row.id || newId(),
      criterion: row.criterion || '',
      score: row.score || '',
      comment: row.comment || '',
    }));
  } catch {
    return defaultCriteria();
  }
}

function SmallGroupEvalPreviewView({ detail }: Props) {
  const criteria = parseCriteria(detail.criteriaJson);

  return (
    <div className="quality-form">
      <section className="quality-form__section">
        <div
          style={{
            display: 'flex',
            justifyContent: 'space-between',
            gap: 16,
            alignItems: 'flex-start',
            marginBottom: 12,
          }}
        >
          <h3 style={{ margin: 0 }}>활동 평가표</h3>
          <ApprovalStampBox
            authorName={detail.authorName}
            reviewerName={detail.reviewerName}
            approverName={detail.approverName}
          />
        </div>
        <div className="quality-form__grid">
          <label>
            평가표번호
            <input readOnly value={detail.evaluationNo || ''} />
          </label>
          <label>
            소집단 *
            <input readOnly value={detail.groupName || '-'} />
          </label>
          <label>
            평가일
            <input type="date" readOnly value={detail.evaluationDate || ''} />
          </label>
          <label className="is-span-2">
            제목
            <input readOnly value={detail.title || ''} />
          </label>
          <label>
            대상기간 시작
            <input type="date" readOnly value={detail.periodFrom || ''} />
          </label>
          <label>
            대상기간 종료
            <input type="date" readOnly value={detail.periodTo || ''} />
          </label>
          <label>
            평가자
            <input readOnly value={detail.evaluator || ''} />
          </label>
          <label>
            종합점수
            <input readOnly value={detail.scoreText || ''} />
          </label>
        </div>

        <div style={{ marginTop: 16 }}>
          <div style={{ marginBottom: 8 }}>
            <strong>평가 항목</strong>
          </div>
          {criteria.map((item) => (
            <div
              key={item.id}
              className="quality-form__grid"
              style={{
                marginBottom: 10,
                padding: 12,
                border: '1px solid #e2e8f0',
                borderRadius: 8,
              }}
            >
              <label className="is-span-2">
                평가항목
                <textarea rows={2} readOnly value={item.criterion} />
              </label>
              <label>
                점수
                <input readOnly value={item.score} />
              </label>
              <label className="is-span-2">
                의견
                <textarea rows={2} readOnly value={item.comment} />
              </label>
            </div>
          ))}
        </div>

        <div className="quality-form__grid" style={{ marginTop: 12 }}>
          <label className="is-span-2">
            강점
            <textarea rows={2} readOnly value={detail.strengths || ''} />
          </label>
          <label className="is-span-2">
            개선점
            <textarea rows={2} readOnly value={detail.improvements || ''} />
          </label>
          <label className="is-span-2">
            종합의견
            <textarea rows={3} readOnly value={detail.overallComment || ''} />
          </label>
          <label className="is-span-2">
            비고
            <textarea rows={2} readOnly value={detail.remark || ''} />
          </label>
        </div>
      </section>
    </div>
  );
}

export default SmallGroupEvalPreviewView;
